import { isClient } from './env';

export const isBybitApp = () => {
  if (!isClient) {
    return false;
  }
  return window.navigator.userAgent.indexOf('bybit_app') > -1;
};

// 判断在web3小程序里
export const isInWeb3Mini = () => {
  if (!isClient) {
    return false;
  }
  return isBybitApp() && window.navigator.userAgent.indexOf('web3') > -1;
};

// 判断是否在Web3小程序的那种不带导航的浏览器中（网页可控制除状态栏的所有位置）
export const isInWeb3FullBrowser = () => {
  return (
    isBybitApp() && window.navigator.userAgent.indexOf('web3_no_toolbar') > -1
  );
};

export const goWeb3MiniHome = () => {
  if ((window as any).ethereum?.closeAndGoToWeb3Home) {
    (window as any).ethereum.closeAndGoToWeb3Home();
  }
};
